import { DefaultPointType } from './XYDataProps';

export const defaultXGetter = <TXValueType, TPointType extends DefaultPointType<TXValueType>>(
  d: TPointType,
): TPointType[0] => d[0];
export const defaultYGetter = <TPointType extends DefaultPointType>(d: TPointType): TPointType[1] => d[1];
